import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Box,
} from "@chakra-ui/react"

/**
 * DetailsModal — Chakra Modal wrapper that hosts an existing Insights
 * detail component (DormantStock, CostSales, Bottom10, etc).
 *
 * The hosted component re-fetches its own data on mount with its own period
 * selector — that's intentional. The modal is a deep-dive workspace.
 *
 * Props:
 *   isOpen   — boolean
 *   onClose  — () => void
 *   title    — string shown in modal header
 *   children — the existing detail component
 */
const DetailsModal = ({ isOpen, onClose, title, children }) => (
  <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside" isCentered>
    <ModalOverlay bg="blackAlpha.500" backdropFilter="blur(4px)" />
    <ModalContent borderRadius="20px" maxH="92vh">
      <ModalHeader fontSize="md" pb={2}>
        {title}
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={6}>
        <Box>{children}</Box>
      </ModalBody>
    </ModalContent>
  </Modal>
)

export default DetailsModal
